/** @type {import('../help-index.js').HelpSidebarItem} */
export const TAX_SET_LINKS_ITEM = {
  id: 'sub_nav_2',
  screenId: 'tax-set-links',
  label: 'Relación impuesto ↔ alícuota',
  description: 'Ver y administrar alícuotas de un impuesto.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Vista centrada en un impuesto: elegís cuál y ves o agregás las alícuotas que le corresponden, sin mezclar con otros impuestos.',
      },
      {
        title: 'Paso 1 — Elegir impuesto',
        fields: [
          {
            label: 'Impuesto',
            description: 'Lista desplegable con impuestos activos (ID y descripción). Al cambiar, se actualiza la lista de alícuotas.',
          },
        ],
      },
      {
        title: 'Paso 2 — Lista de alícuotas del impuesto',
        bullets: [
          'Columnas: ID alícuota, Alícuota (%), Activo.',
          'Botón + — agrega una alícuota ya vinculada al impuesto elegido (no tenés que volver a seleccionarlo).',
          'Tocá una fila para editar porcentaje, activo o desactivar.',
        ],
      },
      {
        title: 'Diferencia con la pestaña Alícuotas',
        paragraphs: [
          '«Alícuotas» muestra todas las alícuotas del sistema. Acá trabajás impuesto por impuesto, útil cuando configurás IIBB o percepciones con varios porcentajes.',
        ],
      },
    ],
  },
}
